import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import {
  RequestFindDataDto, RequestReviseDto,
  ResponseFindDataDto,
  ResponseGetDestinationDto,
  RequestFindDataDeclarationDto
} from "../dto/sf-business-trip-declaration.dto";

@Injectable()
export class SfBusinessTripDeclarationApi {

  private service: string = '';
  private model: string = 'SfBusinesstripdeclaration';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getDestination(): Observable<ResponseGetDestinationDto> {

    const method: string = 'POST';
    const func: string = 'getDestination';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetDestinationDto>(method, url, params, urlParams, body);
  }

  public findData(payload: RequestFindDataDto): Observable<ResponseFindDataDto> {

    const method: string = 'POST';
    const func: string = 'findData';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFindDataDto>(method, url, params, urlParams, body);
  }

  public add(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestReviseDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public findDataDeclaration(payload: RequestFindDataDeclarationDto): Observable<ResponseFindDataDto> {
    const method: string = 'POST';
    const func: string = 'findDataDeclaration';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFindDataDto>(method, url, params, urlParams, body);
  }

  public deleteDraft(requestNo: string): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = { requestNo };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-business-trip-declaration.api.ts